import { Button } from '@repo/shadcn';
import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';

import { Route } from '@/constants';
import { SalesReturnSchemaType } from '@/features/slice/sales-return';

export const salesReturnListColumn: ColumnDef<SalesReturnSchemaType>[] = [
    {
        accessorKey: 'invoice_number',
        header: () => <div>Invoice Number</div>,
        cell: ({ row }) => (
            <Link to={`${Route.SALES_RETURNS}/${row.original.id}`}>
                <span
                    className={
                        'font-medium hover:cursor-pointer hover:underline'
                    }
                >
                    {row.original.invoice_number}
                </span>
            </Link>
        ),
    },
    {
        accessorKey: 'created_at',
        header: () => <div>Date</div>,
        cell: ({ row }) => (
            <span>
                {new Date(row.original.created_at).toLocaleDateString()}
            </span>
        ),
    },

    {
        accessorKey: 'total_items',
        header: () => <span className={'block text-right'}>Total Items</span>,
        cell: ({ row }) => (
            <span className={'block text-right'}>
                {row.original.items?.length ?? 0}
            </span>
        ),
    },

    {
        accessorKey: 'actions',
        header: () => <span className={'block text-right'}>Actions</span>,
        cell: ({ row }) => (
            <div className={'flex justify-end'}>
                <Link
                    to={`${Route.SALES_RETURNS}/${row.original.id}`}
                    className={''}
                >
                    <Button
                        type={'button'}
                        variant={'outline'}
                        className={''}
                        size={'sm'}
                    >
                        View Details
                    </Button>
                </Link>
            </div>
        ),
    },
];
